/* TRYOVIA - Add To Cart ultra-réactif — ouverture immédiate tiroir + feedback instantané */
function tryoviaAddToCart(variantId, quantity, btn) {
  quantity = quantity || 1;
  if (!variantId) return;

  var cartDrawer = document.querySelector('cart-drawer');
  var routes = window.routes || {};

  /* Feedback visuel IMMÉDIAT */
  if (btn) {
    btn.disabled = true;
    btn.dataset.originalText = btn.dataset.originalText || btn.innerText;
    btn.innerText = 'Ajout...';
    btn.style.opacity = '0.7';
  }

  /* Ouverture IMMÉDIATE du tiroir pendant le fetch */
  if (cartDrawer) {
    cartDrawer.classList.remove('is-empty');
    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      cartDrawer.setAttribute('open', '');
      cartDrawer.classList.add('active');
    }
  }

  fetch((routes.cart_add_url || '/cart/add'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    if (data && data.status) { throw new Error(data.description || 'add error'); }

    /* Mise à jour du contenu du tiroir */
    if (cartDrawer) {
      cartDrawer.classList.remove('is-empty');
      if (data && data.sections && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
        cartDrawer.classList.remove('is-empty');
        /* Réouvrir après renderContents qui peut refermer */
        setTimeout(function() {
          cartDrawer.classList.remove('is-empty');
          if (typeof cartDrawer.open === 'function') cartDrawer.open();
        }, 50);
      }
    }

    /* Mise à jour icône panier header */
    if (data && data.sections && data.sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) bubble.innerHTML = data.sections['cart-icon-bubble'];
    }

    /* Pub/Sub Dawn */
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tryovia-atc', cartData: data });
    }

    /* Feedback succès */
    if (btn) {
      btn.innerText = '✓ Ajouté';
      btn.style.opacity = '1';
      btn.style.background = '#2a7a2a';
      btn.style.borderColor = '#2a7a2a';
      setTimeout(function() {
        btn.disabled = false;
        btn.innerText = btn.dataset.originalText;
        btn.style.background = '';
        btn.style.borderColor = '';
        btn.style.opacity = '';
      }, 2200);
    }
  })
  .catch(function(err) {
    console.error('Erreur ajout panier:', err);
    if (btn) {
      btn.disabled = false;
      btn.innerText = btn.dataset.originalText || 'Ajouter au panier →';
      btn.style.opacity = '';
    }
    /* Fallback : redirection panier */
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  });
}

/* Sync sticky vs cart-drawer open */
(function() {
  function syncStickyVsCart() {
    var cd = document.querySelector('cart-drawer');
    var open = !!(cd && cd.classList.contains('active'));
    document.documentElement.classList.toggle('tv-cart-open', open);
  }
  function initStickyWatch() {
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) {
      new MutationObserver(syncStickyVsCart).observe(cd, { attributes: true, attributeFilter: ['class'] });
    }
    syncStickyVsCart();
  }
  if (document.readyState !== 'loading') { initStickyWatch(); }
  else { document.addEventListener('DOMContentLoaded', initStickyWatch); }
})();
